import { BaseRepository } from "@/repositories/base-repository.ts"
import type { IIncomingInvoicePurchase } from "@/interfaces/api/incoming-invoice-purchase.interface.ts"

export class IncomingInvoicePurchaseRepository extends BaseRepository<IIncomingInvoicePurchase> {
  protected resourcePath = "administration/incoming-invoices-purchases"
}
